import utils from 'utils';
import {UiCheckbox} from '@components/ui/typo/UiCheckbox.tsx';

export const SidePanelListItem = (props: {
    mode: 'product' | 'order',
    item: apiProduct | apiOrder,
    loading: boolean,
    active: boolean,

    onClick: () => void,
}) => {
    // fixme: move to new component - start
    const qtyDone = !props.loading ? props.item.qtyDone : '-';
    const qtyToDo = !props.loading ? props.item.qtyToDo : '-';

    const itemsCountFieldJsx = <div className={classMap.dataRowField + ' ' + classMap.dataRowFieldCount}>
        <div>
            {
                props.item.isDone ?
                    <span className={classMap.dataRowFieldDone}>{qtyDone}</span> :
                    props.item.qtyDone ?
                        <span className={classMap.dataRowFieldInProgress}>{qtyDone}</span> :
                        <span>{qtyDone}</span>
            }
            {
                props.item.isDone ?
                    <span className={classMap.dataRowFieldDone}> / {qtyToDo}</span> :
                    <span>{' / ' + qtyToDo}</span>
            }
        </div>
    </div>;
    // fixme: move to new component - end

    return <div
        className={cmpClass + (props.loading ? ' ' + cmpClass + '--loading' : '')}
        onClick={() => props.onClick()}
    >
        {
            props.active ?
                <div
                    className={classMap.background}
                    style={{color: props.item.statusColor}}
                ></div> :
                <></>
        }
        <div
            className={
                classMap.statusBar +
                (props.active ? ' ' + classMap.statusBarActive : '')
            }
        >
            {
                props.mode === 'order' && (props.item as apiOrder).createdBy?.code ?
                    <span
                        className={classMap.statusBarCreatedBy}
                        style={{background: (props.item as apiOrder).createdBy.color}}
                    >
                        {(props.item as apiOrder).createdBy.code}
                    </span> :
                    <></>
            }
            <div
                className={classMap.statusBarDivider}
                style={{borderTopColor: props.item.statusColor}}
            >
            </div>
            <span
                style={{background: props.item.statusColor}}
                className={classMap.statusBarText}
            >
                {props.item.statusText}
            </span>
        </div>
        <div className={classMap.info}>
            <div className={classMap.data}>
                <div className={classMap.dataRow}>
                    <span className={classMap.dataRowField + ' ' + classMap.dataRowFieldBold}>
                        {
                            props.mode === 'order' && (props.item as apiOrder).orderNum
                        }
                        {
                            props.mode === 'product' && (props.item as apiProduct).name
                        }
                    </span>
                    {
                        props.mode === 'order' && <>
                            <span className={classMap.dataRowField}>
                                {(props.item as apiOrder).accountName}
                                {
                                    (props.item as apiOrder).customerName ?
                                        <>
                                            <br />
                                            {(props.item as apiOrder).customerName}
                                        </> :
                                        <></>
                                }
                            </span>
                        </>
                    }
                </div>
                <div className={classMap.dataRow}>
                    {
                        props.mode === 'order' && <>

                            {
                                itemsCountFieldJsx
                            }
                            {
                                (props.item as apiOrder).note ?
                                    <span className={classMap.dataRowField + ' ' + classMap.dataRowFieldNote}>
                                        <i className={'iconfa-note'}></i>
                                        {' : ' + (!props.loading ? (props.item as apiOrder).note : '-')}
                                    </span> : <></>
                            }
                        </>
                    }
                    {props.mode === 'product' && itemsCountFieldJsx}
                </div>
            </div>

            <div className={classMap.statusIcon}>
                {
                    props.mode === 'order' ?
                        <div
                            className={'ready-for-collect__checkbox' + ((props.item as apiOrder).readyForCollect ? ' checked' : '')}
                            onClick={(e) => e.preventDefault()}
                        >
                            <UiCheckbox
                                onChange={() => {}}
                                checked={(props.item as apiOrder).readyForCollect}
                                disabled={props.loading}
                            />
                        </div> : <></>
                }
            </div>
        </div>
    </div>;
};

const cmpClass = 'side-panel-list-item';

const classMap = utils.generateClassMap(cmpClass, {
    statusBar: 'status-bar',
    statusBarActive: 'status-bar--active',
    statusBarText: 'status-bar-text',
    statusBarCreatedBy: 'status-bar-created-by',
    statusBarDivider: 'status-bar-divider',
    statusIcon: 'status-icon',
    background: 'background',
    data: 'data',
    dataRow: 'data-row',
    info: 'info',
    dataRowField: 'data-row-field',
    dataRowFieldBold: 'data-row-field--bold',
    dataRowFieldCount: 'data-row-field--count',
    dataRowFieldDone: 'data-row-field--done',
    dataRowFieldNote: 'data-row-field--note',
    dataRowFieldInProgress: 'data-row-field--in-progress',
});
